import { useParams } from "@reach/router";
import { useState, useRef, useEffect } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

import { useDesigns } from "../../hooks/useDesigns";
import { useProject } from "../../hooks/useProject";
import { useTeam } from "../../hooks/useTeam";
import { sumNumbers } from "./Projects";
import { useReducer } from "react";
import { v4 } from "uuid";
import { api } from "../../util/api";
import PlaylistAddIcon from "@mui/icons-material/PlaylistAdd";
import PlaylistRemoveIcon from "@mui/icons-material/PlaylistRemove";
import { TextFieldTWSolo } from "../../comp/tw/TextField";
import { ButtonTW } from "../../comp/tw/Button";
import SaveIcon from "@mui/icons-material/Save";
import { enqueueSnackbar } from "notistack";

const Quote = ({ costPerFt, pricePerFtBeforeTax }) => {
  const { projectId } = useParams();
  const { designs, isLoading, error } = useDesigns();
  const {
    project,
    isLoading: projectIsLoading,
    error: projectError,
    mutate,
  } = useProject(projectId);
  const { teamIsLoading, team, error: errorLoading } = useTeam();
  // const [removal, setRemoval] = useState(false);
  const timeoutRef = useRef(null);

  if (isLoading || projectIsLoading || teamIsLoading) {
    return <div className="spinner" />;
  }

  if (error || projectError || errorLoading) {
    return (
      <p>
        Error! please refresh the page, if the problem persists contact
        fencewizapp@gmail.com
      </p>
    );
  }
  const design = designs.find((design) => design.id === project.designId);

  const lengths = sumNumbers(Object.values(project.lengths));

  // let removalCost = 0;
  // if (removal) {
  //   removalCost = team.team.removalCostPerFt * lengths;
  // }

  // console.log(extrasCost);

  // console.log(subtotal);

  return (
    <>
      <div className="my-4">
        <TextFieldTWSolo
          type="number"
          value={project.adjustCost}
          label="Cost Adjustment Per Ft"
          onChange={(e) => {
            mutate(
              { ...project, adjustCost: e.target.value },
              {
                optimisticData: { ...project, adjustCost: e.target.value },
                revalidate: false,
              },
            );

            clearTimeout(timeoutRef.current);
            timeoutRef.current = setTimeout(() => {
              api("PUT", `/project/${projectId}`, {
                adjustCost: e.target.value,
              });
              // mutate();
              // Perform other actions here, like making API calls or updating state
            }, 500);

            // }, 2);
            // dispatch({
            //   type: "updateItem",
            //   payload: { id: extra.id, item: e.target.value },
            // });
          }}
        />
      </div>
      <Extras />

      <A4Estimate
        key={`${projectId}-estimate`}
        project={project}
        clientName={`${project.clientFirstName} ${project.clientLastName}`}
        address={project.address}
        city={project.city}
        state={project.state}
        notes={project.notes}
        lineItems={[
          {
            item: design.name,
            ft: `${lengths}ft`,
            quantity: lengths,
            price: pricePerFtBeforeTax,
          },
          ...(project?.extras ? project.extras : []),
        ]}
        team={team}
        design={design}
        pricePerFtBeforeTax={pricePerFtBeforeTax}
        lengths={lengths}
      />

      {/* <Card>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <img src={team.team.logo} style={{ width: "35%" }} />
            <h3>{team.team.website}</h3>
          </div>
          <div>
            <h3>Estimate:</h3>
            <p>{new Date().toDateString()}</p>
            <h5>Prepared For:</h5>
            <div>
              <p>
                {project.clientFirstName} {project.clientLastName}
              </p>
              <p>{project.clientPhone}</p>
              <p>{project.address}</p>
              <p>{project.city}</p>
            </div>
            <div>
              <img
                src={design.image}
                style={{ width: "100%", maxWidth: "400px" }}
              />
            </div>
            <Grid container>
              <Grid item xs={12}>
                <p>{design.name} </p>
              </Grid>
              <Grid item xs={6}>
                <p>
                  ${pricePerFtBeforeTax} x {lengths}ft
                </p>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <p>${totalCost.toFixed(2)}</p>
              </Grid>
            </Grid>

            {project.extras?.length
              ? project.extras.map((extra, key) => {
                  return (
                    <Grid key={`${key}-extras`} container>
                      <Grid item xs={12}>
                        <p>{extra.item} </p>
                      </Grid>
                      <Grid item xs={6}>
                        <p>
                          ${extra.price} x {extra.quantity}
                        </p>
                      </Grid>
                      <Grid item xs={2}></Grid>
                      <Grid item xs={2}>
                        <p>${(extra.price * extra.quantity).toFixed(2)}</p>
                      </Grid>
                    </Grid>
                  );
                })
              : null}

            {removal ? (
              <Grid container>
                <Grid item xs={12}>
                  <p>Removal and Disposal </p>
                </Grid>
                <Grid item xs={6}>
                  <p>
                    ${team.team.removalCostPerFt} x {lengths}ft
                  </p>
                </Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}>
                  <p>${removalCost.toFixed(2)}</p>
                </Grid>
              </Grid>
            ) : null}

            <Grid container>
              <Grid item xs={3}></Grid>

              <Grid item xs={3}>
                <p>Subtotal: </p>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <p>${subtotal.toFixed(2)}</p>
              </Grid>
            </Grid>
            <Grid container>
              <Grid item xs={3}></Grid>

              <Grid item xs={3}>
                <p>
                  {team.team.stateTax}% {team.team.state} Tax:
                </p>
              </Grid>
              <Grid item xs={2}></Grid>
              <Grid item xs={2}>
                <p>${tax.toFixed(2)}</p>
              </Grid>
            </Grid>
          </div>
        </div>
      </Card> */}
    </>
  );
};

export const A4Estimate = ({
  project,
  clientName,
  address,
  city,
  state,
  notes,
  lineItems,
  // extras,
  // length,
  // subtotal,
  // tax,
  team,
  design,
  pricePerFtBeforeTax,
  // lengths,
}) => {
  const { projectId } = useParams();
  const [imageData, setImageData] = useState(null);
  const [designImage, setDesignImage] = useState(null);
  const [splitCost, setSplitCost] = useState(project?.splitCost || false);

  const toggleSplit = async () => {
    const newVal = !splitCost;
    setSplitCost(newVal);
    await api("PUT", `/project/${projectId}`, { splitCost: newVal });
  };

  useEffect(() => {
    const fetchImage = async (url, set) => {
      try {
        const response = await fetch(url, {
          mode: "cors",
          credentials: "omit",
        });

        if (!response.ok) {
          console.warn(`Failed to fetch image: ${response.status}`);
          // Fall back to using the URL directly
          set(url);
          return;
        }

        const blob = await response.blob();
        const reader = new FileReader();

        reader.onloadend = () => {
          const base64String = reader.result;
          set(base64String);
        };

        reader.onerror = () => {
          console.warn("FileReader error, falling back to URL");
          set(url);
        };

        reader.readAsDataURL(blob);
      } catch (error) {
        console.warn("Error fetching image, falling back to URL:", error);
        // Fall back to using the URL directly
        set(url);
      }
    };

    if (team.team.logo) {
      fetchImage(team.team.logo, setImageData);
    }

    if (design.image) {
      fetchImage(design.image, setDesignImage);
    }
  }, [team.team.logo, design.image]);

  const pdfRef = useRef();

  const generatePDF = () => {
    enqueueSnackbar("Downloading...");

    const input = pdfRef.current;

    html2canvas(input, {
      scale: 1.5, // Reduced from 2 for smaller file size
      useCORS: true, // Enable cross-origin images
      logging: false, // Reduce console noise
      allowTaint: false, // Don't allow tainted canvas
      backgroundColor: "#ffffff",
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/jpeg", 0.75); // Use JPEG with 75% quality instead of PNG
      const pdf = new jsPDF({
        orientation: "portrait",
        unit: "mm",
        format: "a4",
        compress: true, // Enable PDF compression
      });

      const pageWidth = pdf.internal.pageSize.getWidth();
      const pageHeight = pdf.internal.pageSize.getHeight();
      const imgRatio = canvas.width / canvas.height;
      let imgWidth, imgHeight;

      if (imgRatio > pageWidth / pageHeight) {
        // Image is wider than the page, adjust width
        imgWidth = pageWidth;
        imgHeight = imgWidth / imgRatio;
      } else {
        // Image is taller than the page, adjust height
        imgHeight = pageHeight;
        imgWidth = imgHeight * imgRatio;
      }

      const x = (pdf.internal.pageSize.getWidth() - imgWidth) / 2;
      const y = (pdf.internal.pageSize.getHeight() - imgHeight) / 2;

      pdf.addImage(imgData, "JPEG", x, y, imgWidth, imgHeight);
      pdf.save(`${clientName} Estimate.pdf`);

      enqueueSnackbar("Downloaded...", { variant: "success" });
    });
  };

  // const totalCost =
  //   sumNumbers(Object.values(project.lengths)) * pricePerFtBeforeTax;
  // const lengths = sumNumbers(Object.values(project.lengths));

  // let removalCost = 0;
  // if (removal) {
  //   removalCost = team.team.removalCostPerFt * lengths;
  // }

  const subtotal = sumNumbers(
    lineItems.map((item) => parseFloat(item.price) * parseFloat(item.quantity)),
  );
  // console.log(subtotal);
  const tax = subtotal * ((team?.team?.serviceTax || 0) / 100 + 1) - subtotal;
  const accent = team?.team?.colorCode || "#fdd835";

  return (
    <>
      <div className="flex gap-2 mb-2 mv-2">
        <ButtonTW onClick={generatePDF} label={"Download as PDF"} />
        {/* <ButtonTW
          onClick={toggleSplit}
          label={splitCost ? "½ Split: ON" : "½ Split"}
          variant={splitCost ? "primary" : "secondary"}
        /> */}
      </div>

      <div
        ref={pdfRef}
        className="bg-white mx-auto my-4 sm:my-10 shadow-md w-full max-w-[210mm] text-gray-800 overflow-hidden border border-gray-200"
      >
        {/* Dark header */}
        <div className="relative bg-[#181c24] overflow-hidden">
          <svg
            className="absolute top-0 right-0 h-full pointer-events-none"
            style={{ width: "55%" }}
            viewBox="0 0 440 200"
            fill="none"
            preserveAspectRatio="none"
          >
            <polygon points="440,0 200,0 100,200 440,200" fill="#1e2637" />
            <polygon points="440,0 300,0 210,200 440,200" fill="#252f41" />
            <polygon points="440,0 370,0 330,200 440,200" fill="#1a2030" />
          </svg>

          {/* Company name */}
          <div className="relative z-10 px-4 sm:px-10 pt-7 pb-3 border-b border-white/10">
            <span className="text-white font-bold text-sm sm:text-base uppercase tracking-widest">
              {team?.team?.name}
            </span>
          </div>

          {/* FENCE PROPOSAL title + logo */}
          <div className="relative z-10 px-4 sm:px-10 pt-5 pb-9 flex items-center justify-between">
            <div>
              <div
                className="text-white font-black uppercase leading-none"
                style={{ fontSize: 'clamp(26px, 8vw, 44px)', letterSpacing: "-2px" }}
              >
                FENCE
              </div>
              <div
                className="font-black uppercase leading-none"
                style={{ fontSize: 'clamp(26px, 8vw, 44px)', letterSpacing: "-2px", color: accent }}
              >
                PROPOSAL
              </div>
            </div>
            {imageData && (
              <img
                src={imageData}
                alt="logo"
                className="h-14 sm:h-24 w-auto object-contain bg-white rounded-xl px-3 py-2 mr-2 sm:mr-4"
                style={{ boxShadow: "0 4px 20px rgba(0,0,0,0.4)" }}
              />
            )}
          </div>
        </div>

        {/* Client info + project summary */}
        <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 px-4 sm:px-10 py-6 sm:py-8 bg-white">
          <div className="flex-1">
            <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold">
              Prepared For
            </p>
            <div className="flex items-center gap-2 mt-2">
              <div
                className="w-0.5 h-8 rounded-full shrink-0"
                style={{ backgroundColor: accent }}
              />
              <p className="text-2xl font-extrabold text-gray-900">
                {clientName}
              </p>
            </div>
            <div className="pl-3 mt-2 space-y-1">
              {project?.clientPhone && (
                <p className="text-sm text-gray-500">· {project.clientPhone}</p>
              )}
              {address && <p className="text-sm text-gray-500">· {address}</p>}
              {(city || state) && (
                <p className="text-sm font-semibold text-gray-700">
                  · {[city, state].filter(Boolean).join(", ")}
                </p>
              )}
            </div>
          </div>
          <div className="shrink-0 sm:text-right flex flex-col sm:items-end gap-3">
            <div>
              <p className="text-xs text-gray-400 uppercase tracking-widest font-semibold mb-1">
                Date
              </p>
              <p className="text-sm font-bold text-gray-800">
                {new Date().toDateString()}
              </p>
            </div>
            {designImage && (
              <img
                src={designImage}
                alt="design"
                className="w-full sm:w-64 h-40 sm:h-48 rounded-lg object-cover border border-gray-200"
              />
            )}
          </div>
        </div>

        <div className="mx-4 sm:mx-10 h-px bg-gray-200" />

        {/* Project Details / Notes */}
        {notes && (
          <section className="px-4 sm:px-10 py-6">
            <div className="flex items-center gap-3 mb-3">
              <div
                className="w-1 h-5 rounded-full"
                style={{ backgroundColor: accent }}
              />
              <h2 className="text-base font-black uppercase tracking-wide text-gray-800">
                Project Details
              </h2>
            </div>
            <p
              className="text-sm text-gray-600 leading-relaxed"
              style={{ whiteSpace: "pre-wrap" }}
            >
              {notes}
            </p>
          </section>
        )}

        {/* Line Items */}
        <section className="px-4 sm:px-10 py-6">
          <div className="flex items-center gap-3 mb-4">
            <div
              className="w-1 h-5 rounded-full"
              style={{ backgroundColor: accent }}
            />
            <h2 className="text-base font-black uppercase tracking-wide text-gray-800">
              Line Items
            </h2>
          </div>

          {/* Table */}
          <div className="overflow-x-auto">
            {/* Table header */}
            <div className="grid grid-cols-3 sm:grid-cols-5 text-xs font-black uppercase tracking-wide bg-[#181c24] text-white rounded-t-lg min-w-[280px]">
              <p className="p-2 sm:p-3 col-span-1 sm:col-span-2">Item</p>
              <p className="p-2 sm:p-3 hidden sm:block">Quantity</p>
              <p className="p-2 sm:p-3 hidden sm:block">Unit Price</p>
              <p className="p-2 sm:p-3">Qty</p>
              <p className="p-2 sm:p-3 text-right">
                {splitCost ? "Your Share" : "Total"}
              </p>
            </div>

            {/* Table rows */}
            {lineItems &&
              lineItems.map((item, idx) => (
                <div
                  key={`${idx}-line-item`}
                  className={`grid grid-cols-3 sm:grid-cols-5 text-xs sm:text-sm border-b border-gray-100 min-w-[280px] ${
                    idx % 2 === 0 ? "bg-gray-50" : "bg-white"
                  }`}
                >
                  <p className="p-2 sm:p-3 col-span-1 sm:col-span-2 font-medium">{item.item}</p>
                  <p className="p-2 sm:p-3 text-gray-500 hidden sm:block">
                    {item.ft ? item.ft : item.quantity}
                  </p>
                  <p className="p-2 sm:p-3 text-gray-500 hidden sm:block">
                    ${parseFloat(item.price).toFixed(2)}
                  </p>
                  <p className="p-2 sm:p-3 text-gray-500 block sm:hidden">
                    {item.ft ? item.ft : item.quantity}
                  </p>
                  <p className="p-2 sm:p-3 text-right font-semibold">
                    $
                    {splitCost
                      ? (
                          (parseFloat(item.price) * parseFloat(item.quantity)) /
                          2
                        ).toFixed(2)
                      : (
                          parseFloat(item.price) * parseFloat(item.quantity)
                        ).toFixed(2)}
                  </p>
                </div>
              ))}
          </div>
        </section>

        {/* Totals */}
        <div className="px-4 sm:px-10 pb-10">
          <div className="ml-auto w-full sm:w-64 rounded-lg overflow-hidden border border-gray-200">
            <div className="p-4 space-y-2 bg-white">
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">Subtotal</span>
                <span className="font-semibold">${subtotal.toFixed(2)}</span>
              </div>
              <div className="flex justify-between text-sm">
                <span className="text-gray-500">
                  Tax ({team?.team?.serviceTax || 0}%)
                </span>
                <span className="font-semibold">${tax.toFixed(2)}</span>
              </div>
              {splitCost && (
                <>
                  <div className="flex justify-between text-sm border-t border-gray-100 pt-2">
                    <span className="text-gray-500">Full Total</span>
                    <span className="font-semibold">
                      ${(subtotal + tax).toFixed(2)}
                    </span>
                  </div>
                  <div className="flex justify-between text-sm">
                    <span className="text-gray-500">
                      Neighbour&apos;s Share (½)
                    </span>
                    <span className="font-semibold">
                      − ${((subtotal + tax) / 2).toFixed(2)}
                    </span>
                  </div>
                </>
              )}
            </div>
            <div className="bg-[#181c24] p-4 flex justify-between items-center">
              <span className="text-white font-black uppercase tracking-widest text-sm">
                {splitCost ? "Your Share" : "Total"}
              </span>
              <span className="font-black text-xl" style={{ color: accent }}>
                $
                {splitCost
                  ? ((subtotal + tax) / 2).toFixed(2)
                  : (subtotal + tax).toFixed(2)}
              </span>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="relative bg-[#181c24] h-14 overflow-hidden">
          <svg
            className="absolute bottom-0 right-0 h-full"
            style={{ width: "45%" }}
            viewBox="0 0 360 60"
            fill="none"
            preserveAspectRatio="none"
          >
            <polygon points="360,0 150,0 120,60 360,60" fill="#1e2637" />
            <polygon points="360,0 250,0 230,60 360,60" fill="#252f41" />
          </svg>
          <div className="relative z-10 px-4 sm:px-10 h-full flex items-center justify-between">
            <p className="text-white text-xs opacity-60">
              Thank you for your business!
            </p>
            {team?.team?.website && (
              <p className="text-white text-xs opacity-60">
                {team.team.website}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

// const initState = [{ id: "1", item: "", price: "", quantity: "" }];

function reducer(state, action) {
  if (action.type === "addBlank") {
    return [...state, { id: v4(), item: "", price: "", quantity: "" }];
  }
  if (action.type === "removeItem") {
    console.log(state[0].id, action.payload);
    return state.filter((item) => item.id !== action.payload);
  }

  if (action.type === "updateItem") {
    return state.map((item) => {
      if (item.id === action.payload.id) {
        return { ...item, ...action.payload };
      }
      return item;
    });
  }
}

export const Extras = ({ where = null }) => {
  const { projectId } = useParams();

  const {
    project,
    isLoading: projectIsLoading,
    error: projectError,
    mutate,
  } = useProject(projectId);

  const getInitialExtras = () => {
    if (where === null) {
      return project?.extras || [];
    }
    return project?.splits?.[where]?.extras || [];
  };

  const [extras, dispatch] = useReducer(reducer, getInitialExtras());

  if (projectIsLoading) {
    return <div className="spinner" />;
  }

  if (projectError) {
    return (
      <p>
        Error! please refresh the page, if the problem persists contact
        fencewizapp@gmail.com
      </p>
    );
  }

  const saveRow = () => {
    const payload =
      where === null
        ? { extras }
        : {
            splits: {
              ...project.splits,
              [where]: {
                ...(project.splits?.[where] || {}),
                extras,
              },
            },
          };

    const optimisticData =
      where === null
        ? { ...project, extras }
        : {
            ...project,
            splits: {
              ...project.splits,
              [where]: {
                ...(project.splits?.[where] || {}),
                extras,
              },
            },
          };

    mutate(api("PUT", `/project/${projectId}`, payload), { optimisticData });
    enqueueSnackbar("Line Items Updated", { variant: "success" });
  };

  return (
    <div>
      {extras.map((e, idx) => (
        <QuoteRow
          key={`${idx}-extras`}
          extra={e}
          dispatch={dispatch}
          project={project}
          mutate={mutate}
        />
      ))}
      <div>
        <ButtonTW
          variant="primary"
          label={<PlaylistAddIcon />}
          onClick={() => dispatch({ type: "addBlank" })}
          className="w-24"
        />
        <ButtonTW
          variant="secondary"
          className="ml-2 w-24"
          label={<SaveIcon />}
          onClick={saveRow}
        />
      </div>
    </div>
  );
};

const QuoteRow = ({ extra, dispatch, mutate, project }) => {
  return (
    <div>
      <div className="grid grid-cols-2 md:grid-cols-10 my-2 items-center gap-4">
        <TextFieldTWSolo
          value={extra.item}
          label="Item"
          onChange={(e) => {
            dispatch({
              type: "updateItem",
              payload: { id: extra.id, item: e.target.value },
            });
          }}
          className="md:col-span-3"
        />
        <TextFieldTWSolo
          value={extra.price}
          label="Price ($)"
          onChange={(e) => {
            dispatch({
              type: "updateItem",
              payload: { id: extra.id, price: e.target.value },
            });
          }}
          className="md:col-span-3"
        />
        <TextFieldTWSolo
          value={extra.quantity}
          label="Quantity"
          onChange={(e) => {
            dispatch({
              type: "updateItem",
              payload: { id: extra.id, quantity: e.target.value },
            });
          }}
          className="md:col-span-3"
        />
        <ButtonTW
          label={<PlaylistRemoveIcon />}
          variant="danger"
          // size="small"
          onClick={() => {
            // api("PUT")
            console.log(extra.id);
            dispatch({ type: "removeItem", payload: extra.id });
          }}
          className="md:col-span-1"
        />
      </div>
    </div>
  );
};

export default Quote;
